// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__jm5dh","icon":"styles_icon__XXEw6","label":"styles_label__3kvpe"};